import { useEffect, useState } from 'react';
import ReferralSummaryWidget from '../components/ReferralSummaryWidget';
import ReferralTreePage from '../components/ReferralTreePage';
import {
    getMyWallet,
    getMyCommissions,
    getMyReferralLink,
    getMyReferralStats,
} from './api';
import './wallet.css';

export default function WalletPage() {
    const [wallet, setWallet] = useState(null);
    const [commissions, setCommissions] = useState([]);
    const [link, setLink] = useState(null);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [showTree, setShowTree] = useState(false);

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            setLoading(true);
            setError('');
            try {
                const [walletData, commissionsData, linkData, statsData] =
                    await Promise.all([
                        getMyWallet(),
                        getMyCommissions(),
                        getMyReferralLink(),
                        getMyReferralStats(),
                    ]);
                if (cancelled) return;
                setWallet(walletData);
                setCommissions(commissionsData);
                setLink(linkData);
                setStats(statsData);
            } catch (e) {
                if (!cancelled) setError(e.message);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        load();
        return () => {
            cancelled = true;
        };
    }, []);

    if (loading) {
        return <div className="wallet-loading">در حال بارگذاری...</div>;
    }

    return (
        <div className="wallet-page">
            <header className="wallet-header">
                <h1>کیف پول</h1>
            </header>

            {error && <div className="error-banner">{error}</div>}

            <ReferralSummaryWidget
                onToggleTree={() => setShowTree(!showTree)}
                isTreeOpen={showTree}
            />

            {showTree && (
                <div style={{ marginTop: '1.5rem', animation: 'fadeIn 0.3s ease-in-out' }}>
                    <ReferralTreePage />
                </div>
            )}
        </div>
    );
}